import { SERVER_CONFIGS } from './clientConfigs';
import { CLIENT_NAME, ENV, BRAND_LETTER } from './_global';

export const clientServerConfigs = SERVER_CONFIGS[CLIENT_NAME][ENV];

export default {
    ...clientServerConfigs,
    services: {
        damTokens: `/brands/${BRAND_LETTER}/dam-tokens`,
        miwiAuthentication: '/miwi/authentication/',
        naapContextToken: '/naap/contextToken',
        authCheck:'/connect/audi-cognito/check',
        authToken: '/auth/user-token',
        carModels: `/brands/${BRAND_LETTER}/car-models`,
        carTypes: `/brands/${BRAND_LETTER}/car-types`,
        countries: {
            getAll: '/countries',
            get: '/countries/{id}'
        },
        devices: {
            getAll: `/brands/${BRAND_LETTER}/devices`,
            userDevices: '/users/me/devices',
            get: '/digital-retail/devices/{id}',
            create: '/digital-retail/devices',
            update: '/digital-retail/devices/{id}',
            delete: '/digital-retail/devices/{id}',
            pair: `/brands/${BRAND_LETTER}/devices`
        },
        dealerships: {
            getAll: '/digital-retail/dealerships',
            get: '/digital-retail/dealerships/{id}',
            create: '/digital-retail/dealerships',
            update: '/digital-retail/dealerships/{id}',
            delete: '/digital-retail/dealerships/{id}',
            getOne: `/brands/${BRAND_LETTER}/dealerships`
        },
        dealershipGroup: {
            getAll: `/brands/${BRAND_LETTER}/dealership-groups`,
            get: `/brands/${BRAND_LETTER}/dealership-groups/{id}`,
        },
        distribution: {
            mediaItems: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}`
        },
        media: {
            basePath: '/distribution/media',
            download: '/distribution/media/media/{id}/download'
        },
        refreshToken: '/authentication/cognito/refresh',
        search: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}/search`,
        suggest: {
            search: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}/suggest`
        },
        playlists: {
            getAll: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}/content-playlists`,
            userPlaylists:  '/users/me/content-playlists',
            get: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}/content-playlists`,
            create: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}/content-playlists`,
            fallbacks: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}/content-playlists`,
            update: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}/content-playlists/{id}`,
            items: {
                update: '/digital-retail/content-playlists/{id}/items'
            },
            delete: '/digital-retail/content-playlists/{id}'
        },
        playlistGroups: {
            getAll: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}/content-playlist-groups`,
            get: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}/content-playlist-groups`,
            userPlaylistGroups:  '/users/me/content-playlist-groups',
            create: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}/content-playlist-groups`,
            update: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}/content-playlist-groups/`,
            delete: '/digital-retail/content-playlist-groups/{id}'
        },
        moduleTypes: {
            getAll: `/brands/${BRAND_LETTER}/module-types`
        },
        faqs: {
            getAll: `/brands/${BRAND_LETTER}/channels/${clientServerConfigs.channelSlug}/faqs`
        },
        dealerUploadRule: {
            get: `/brands/${BRAND_LETTER}/dealer-upload-rule`
        },
        dealerUpload: {
            upload: `/brands/${BRAND_LETTER}/dealer-upload`
        },
        assetsOverride: {
            get: '/asset-overrides',
            post: '/asset-overrides',
        },
        users: {
            me: '/users/me',
            userDealerships: '/users/me/dealerships',
            collectionShare: {
                getAll: '/users/me/collection-shares',
                get: '/users/me/collection-shares/{id}',
                delete: '/users/me/collection-shares/{id}'
            },
            search: '/users',
            resetPassword: '/users/me/reset-password',
            groups: {
                get: '/user-groups',
                add: '/user-groups',
                group: '/user-groups/{id}'
            }
        }
    }
};
